import { useTheme } from '@emotion/react';
import { Modal, createStyles, Title, Box, Stack } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';
import dt from '~/testing';

import GameList from './GameList';

const useStyles = createStyles((theme) => ({
  slateBox: {
    borderColor: theme.colors.gray[2],
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: theme.spacing.md / 2,
  },
}));

type GameModalProps = {
  slates: ContestSlate[];
  isOpen: boolean;
  onClose: VoidFunction;
};

function GameModal({ slates = [], isOpen, onClose }: GameModalProps) {
  const { classes } = useStyles();
  const theme = useTheme();
  const { t } = useTranslation('contest');

  return (
    <Modal
      onClose={onClose}
      opened={isOpen}
      title={<Title size={theme.fontSizes.lg}>{t('detail.about.game.modal.title')}</Title>}
      size="lg"
      radius="md"
      fullScreen
    >
      <Stack
        data-test-id={dt.contestDetail.section.about.game.slate.container}
        spacing={theme.spacing.xs}
      >
        {slates.map(({ games, id, name }, index) => (
          <Box pos="relative" key={`${id + index}`} p="md" className={classes.slateBox}>
            <Title
              data-test-id={dt.contestDetail.section.about.game.slate.title}
              mb={theme.spacing.md / 2}
              size={theme.fontSizes.md}
            >
              {name}
            </Title>
            <GameList games={games} />
          </Box>
        ))}
      </Stack>
    </Modal>
  );
}

export default GameModal;
